import { translator } from "../services/TranslatorService";

/**
 * Класс-обёртка для работы с датой для фильтра (календарь)
 * требует загруженные плагины: DateRangePicker.js, Moment.js
 */
export class DatePickerComponent {
	/**
	 * При создании передаем инпут к которому присваевается календарь
	 * и если необходимо изменять или модифицировать календарь
	 * то передаем вторым аргументом объект с параметрами
	 * @param input {HTMLInputElement}
	 * @param params {Object}
	 */
	constructor(input, params = {}) {
		this.dateRangePicker = input || null;
		this.$filterDate = $(input).parents(".js-filter-date");

		this.init(params);
	}

	init(params) {
		if (!this.dateRangePicker) return false;

		this.dateRangePicker.daterangepicker(this.initOptions(params), this.cb.bind(this));

		this.initListeners();
	}

	initOptions(params) {
		return {
			opens: params.opens || "right",
			autoUpdateInput: false,
			minDate: this.formatCurrentDate(),
			locale: {
				format: "DD-MM-YYYY",
				separator: " — ",
				applyLabel: translator.t("main", "Apply"),
				cancelLabel: translator.t("main", "Reset"),
				fromLabel: translator.t("main", "From"),
				toLabel: translator.t("main", "To"),
				daysOfWeek: [
					translator.t("date", "Su"),
					translator.t("date", "Mo"),
					translator.t("date", "Tu"),
					translator.t("date", "We"),
					translator.t("date", "Th"),
					translator.t("date", "Fr"),
					translator.t("date", "Sa"),
				],
				monthNames: [
					translator.t("date", "January"),
					translator.t("date", "February"),
					translator.t("date", "March"),
					translator.t("date", "April"),
					translator.t("date", "May"),
					translator.t("date", "June"),
					translator.t("date", "July"),
					translator.t("date", "August"),
					translator.t("date", "September"),
					translator.t("date", "October"),
					translator.t("date", "November"),
					translator.t("date", "December"),
				],
				firstDay: 1,
			},
		};
	}

	/**
	 * Метод добавляющий обработчик на input или div в зависимости от типа устройства
	 * на мобилке - обработчик на div
	 * на десктопе - обработчик на input
	 * Данный метод реализует открытие/закрытие календаря по нажатию на элемент
	 */
	initListeners() {
		const mobileScreen = window.matchMedia("(max-width: 767px)");
		if (mobileScreen.matches) {
			$(".js-filter-date").on("click", function (e) {
				if (this.classList.contains("opened")) {
					this.classList.remove("opened");
					$(".daterangepicker").slideUp();
				} else {
					this.classList.add("opened");
					$(".daterangepicker").slideDown();
				}
			});
			this.dateRangePicker.on("hide.daterangepicker", () => {
				$(".js-filter-date").removeClass("opened");
				$(".daterangepicker").slideUp();
			});
		} else {
			this.dateRangePicker.on("hide.daterangepicker", () =>
				this.$filterDate.removeClass("opened")
			);
			this.dateRangePicker.on("show.daterangepicker", () =>
				this.$filterDate.addClass("opened")
			);
		}
	}

	cb(start, end) {
		return this.setValByStartAndEnd(start.format("DD-MM-YYYY"), end.format("DD-MM-YYYY"));
	}

	setValByStartAndEnd(formatStart, formatEnd) {
		this.setVal(formatStart + " — " + formatEnd);

		this.$filterDate.removeClass("alone").addClass("double");
		this.dateRangePicker.removeClass("alone").addClass("double");
	}

	/** *****************************************
	 * Методы которые предоставляет компонент:  *
	 * ******************************************
	 */

	/**
	 * Устанавливает подписчиков на событие
	 * @param action {String}
	 * @param fn {Function}
	 */
	on(action, fn) {
		if (action === "apply") {
			this.dateRangePicker.on("apply.daterangepicker", (ev, picker) => fn(ev, picker));
			this.dateRangePicker.on("apply.daterangepicker", function () {
				$(".js-filter-date").removeClass("opened");
			});
		}
		if (action === "cancel") {
			this.dateRangePicker.on("cancel.daterangepicker", (ev, picker) => fn(ev, picker));
			this.dateRangePicker.on("cancel.daterangepicker", function () {
				$(".js-filter-date").removeClass("opened");
				$(".js-filter-date").removeClass("double");
			});
		}
	}

	/**
	 * Метод добавляющий обработчик для кнопок с выбором периода
	 * Например для кнопок: На этой неделе, На выходных...
	 * @example Пример как использовать:
	 * this.dateRangePicker.initDateRangeInputs(); - инициализируем в js
	 * <input class="js-date-range-input" type="radio" data-date-from="15-02-2021" data-date-to="21-02-2021">
	 * @return {Function} Обновляет календарь в соответствии с выбранным периодом
	 */
	initDateRangeInputs() {
		$(".js-date-range-input").on("change", e => {
			const input = $(e.currentTarget);

			if (!input.prop("checked")) return false;

			const start = input.data("date-from");
			const end = input.data("date-to");

			//Выделяем выбранный элемент
			$(".js-date-range-input").removeClass("active");
			input.addClass("active");

			/* Устанавливаем дату начала и окончания (день-месяц-год) */
			this.setValByStartAndEnd(start, end);

			this.setStartDate(start);
			this.setEndDate(end);

			return this.dateRangePicker.trigger(
				"apply.daterangepicker",
				this.dateRangePicker.data("daterangepicker")
			);
		});
	}

	formatCurrentDate() {
		const currentDate = new Date();

		let day = currentDate.getDate();
		day = day < 10 ? "0" + day : day;

		let month = currentDate.getMonth() + 1;
		month = month < 10 ? "0" + month : month;

		const year = currentDate.getFullYear();

		return `${day}/${month}/${year}`;
	}

	clearDateRangeInputs() {
		return $(".js-date-range-input").prop("checked", false).removeClass("active");
	}

	setVal(val) {
		return this.dateRangePicker.val(val);
	}

	setStartDate(date) {
		return this.dateRangePicker.data("daterangepicker").setStartDate(date);
	}

	setEndDate(date) {
		return this.dateRangePicker.data("daterangepicker").setEndDate(date);
	}

	reset() {
		this.setVal(translator.t("main", "Date"));

		this.setStartDate(new Date());
		this.setEndDate(new Date());
	}
}
